import axios from "axios";
import { Firmware } from "./dtos/Firmware.schema";
import { FirmwareVersion } from "./dtos/FirmwareVersion.schema";
import { FirmwareVersion as FirmwareVersionDto } from "./dtos/FirmwareVersion.schema";
// If you have a FirmwareVersion schema, import it too:

const BASE_URL = "/firmwares";

export interface FirmwareVersionUpload {
  version: string;
  file: File | null;
}

export const getFirmwares = async (): Promise<Firmware[]> => {
  const res = await axios.get<Firmware[]>(BASE_URL);
  return res.data;
};

export const getFirmware = async (firmwareId : number): Promise<Firmware> => {
  const res = await axios.get<Firmware>(BASE_URL + `/${firmwareId}`);
  return res.data;
};

export const createFirmware = async (firmware: Firmware): Promise<Firmware> => {
  const form = new URLSearchParams();
  form.append("hardwareType", firmware.hardwareType);
  form.append("name", firmware.name);
  form.append("description", firmware.description);

  const res = await axios.post<Firmware>(BASE_URL, form);

  return res.data;
};

export const updateFirmware = async (firmware: Firmware): Promise<Firmware> => {
  const form = new URLSearchParams();
  form.append("name", firmware.name);
  form.append("description", firmware.description);

  const res = await axios.put<Firmware>(BASE_URL + `/${firmware.id}`, form);

  return res.data;
};

export const deleteFirmware = async (firmwareId : number): Promise<void> => {
  const res = await axios.delete<void>(BASE_URL + `/${firmwareId}`);
  return res.data;
};

export const getFirmwareVersions = async (): Promise<Firmware[]> => {
  const res = await axios.get<Firmware[]>(BASE_URL + `/with-hardwareType`);
  return res.data;
};


export const deleteFirmwareVersion = async (firmwareversionId : number): Promise<void> => {
  const res = await axios.delete<void>(BASE_URL + `/versions/${firmwareversionId}`);
  return res.data;
};

export const createFirmwareVersion = async (
  firmwareId: number,
  firmwareVersion: FirmwareVersionUpload
): Promise<FirmwareVersionDto> => {

  if (!firmwareVersion.file) {
    throw new Error("No file selected for firmware upload");
  }
  const file: File = firmwareVersion.file;

  const form = new FormData();
  form.append("hardwareType", "BIKE_PARK_BOX_CONTROLLER"); // or param
  form.append("version", firmwareVersion.version);
  form.append("file", file);

  const res = await axios.post<FirmwareVersionDto>(
    `${BASE_URL}/${firmwareId}/versions`,
    form,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );

  return res.data;
};

